import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class ApiService {
  // 'https://www.nogal-system.com/nogal-system-backend/'
  baseUrl = 'https://nogal-system.him-eg.com/nogal-system-backend/';
    //  baseUrl = ' http://localhost:3000/';


  constructor(private _HttpClient: HttpClient) { }
  login(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}login`, data , {withCredentials: true});
  }
  Profile(): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}profile`, 'go' , {withCredentials: true}).pipe(
      map((data)=>{
        localStorage.setItem('permission', JSON.stringify(data));
        return data;
      })
    )
  }
  allUsers(): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}allUsers`, 'go' , {withCredentials: true})
  }
  allemployees(): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}allemployees`, 'go' , {withCredentials: true})
  }
  addUser(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}addUsers`, data , {withCredentials: true})
  }
  addAtten(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}addAtten`, data , {withCredentials: true})
  }
  addAttenAcount(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}addAttenAcount`, data , {withCredentials: true})
  }
  addAttenAcount2(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}addAttenAcount2`, data , {withCredentials: true})
  }
  addEmployee(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}addEmployee`, data , {withCredentials: true})
  }
  getRoots(): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}getRoots`, 'go' , {withCredentials: true})
  }
  getRootsId(): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}getRootsId`, 'go' , {withCredentials: true})
  }
  getControls(): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}getControls`, 'go' , {withCredentials: true})
  }
  delU(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}deleteU`, data , {withCredentials: true})
  }
  delUEmployee(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}delUEmployee`, data , {withCredentials: true})
  }
  updateUser(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}updateUser`, data , {withCredentials: true})
  }
  updateEmployee(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}updateEmployee`, data , {withCredentials: true})
  }
  getTypeOfRoot(): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}getTypeOfRoot`, 'go' , {withCredentials: true})
  }
  addRoot(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}addRoot`, data , {withCredentials: true})
  }
  delR(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}deleteR`, data , {withCredentials: true})
  }
  updateR(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}updateR`, data , {withCredentials: true})
  }
  UpdateAllPricesSum(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}updatePriceSum`, data , {withCredentials: true})
  }
  UpdateAllPricesSub(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}updatePriceSub`, data , {withCredentials: true})
  }
  addS(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}addS`, data , {withCredentials: true})
  }
  allS(): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}allS`, 'go' , {withCredentials: true})
  }
  allSId(): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}allSId`, 'go' , {withCredentials: true})
  }
  delS(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}delS`, data , {withCredentials: true})
  }
  delSC(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}delSC`, data , {withCredentials: true})
  }
  updateS(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}updateS`, data , {withCredentials: true})
  }
  updateSC(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}updateSC`, data , {withCredentials: true})
  }
  allI(): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}allI`, 'go' , {withCredentials: true})
  }
  allIFinished(): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}allIFinished`, 'go' , {withCredentials: true})
  }
  allIId(): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}allIId`, 'go' , {withCredentials: true})
  }
  allINoRepeate(): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}allINoRepeate`, 'go' , {withCredentials: true})
  }
  allIPaginated(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}allIPaginated`, data , {withCredentials: true})
  }
  allICodes(): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}allICodes`, 'go' , {withCredentials: true})
  }
  allINoRepeateFinished(): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}allINoRepeateFinished`, 'go' , {withCredentials: true})
  }
  allIPrivateThis(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}allIPrivateThis`, data , {withCredentials: true})
  }
  allIB(): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}allIB`, 'go' , {withCredentials: true})
  }
  allReturn(): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}allReturn`, 'go' , {withCredentials: true})
  }
  addI(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}addI`, data , {withCredentials: true})
  }
  addIAnother(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}addIAnother`, data , {withCredentials: true})
  }
  delI(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}delI`, data , {withCredentials: true})
  }
  goout(): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}goout`, 'go' , {withCredentials: true})
  }
  allIm(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}allIm`, data , {withCredentials: true})
  }
  allImAnother(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}allImAnother`, data , {withCredentials: true})
  }
  allIm0(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}allIm0`, data , {withCredentials: true})
  }
  updateI(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}updateI`, data , {withCredentials: true})
  }
  addCa(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}addCa`, data , {withCredentials: true})
  }
  addCaAcount(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}addCaAcount`, data , {withCredentials: true})
  }
  allCa(): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}allCa`, 'go' , {withCredentials: true})
  }
  allCaId(): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}allCaId`, 'go' , {withCredentials: true})
  }
  allCaAccount(): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}allCaAccount`, 'go' , {withCredentials: true})
  }
  allCaAccountCheck(): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}allCaAccountCheck`, 'go' , {withCredentials: true})
  }
  delCa(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}delCa`, data , {withCredentials: true})
  }
  delCaAccount(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}delCaAccount`, data , {withCredentials: true})
  }
  delCaAccount00(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}delCaAccount00`, data , {withCredentials: true})
  }
  updateCa(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}updateCa`, data , {withCredentials: true})
  }
  updateCaAccount(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}updateCaAccount`, data , {withCredentials: true})
  }
  allpayno(): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}allpayno`, 'go' , {withCredentials: true})
  }
  allpaynoPay(): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}allpaynoPay`, 'go' , {withCredentials: true})
  }
  allpaynoPayNew(): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}allpaynoPayNew`, 'go' , {withCredentials: true})
  }
  addP(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}addP`, data , {withCredentials: true})
  }
  delI0(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}delI0`, data , {withCredentials: true})
  }
  updateI0(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}updateI0`, data , {withCredentials: true})
  }
  addSC(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}addSC`, data , {withCredentials: true})
  }
  allCustomer(): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}allCustomer`, 'go' , {withCredentials: true})
  }
  allCustomerAllSales(): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}allCustomerAllSales`, 'go' , {withCredentials: true})
  }
  allCustomerOffer(): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}allCustomerOffer`, 'go' , {withCredentials: true})
  }
  allCustomerPOffer(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}allCustomerPOffer`, data , {withCredentials: true})
  }
  addPay(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}addPay`, data , {withCredentials: true})
  }
  addPay00(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}addPay00`, data , {withCredentials: true})
  }
  addPayOrder(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}addPayOrder`, data , {withCredentials: true})
  }
  getItemBooked(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}getItemBooked`, data , {withCredentials: true})
  }
  getItemBookedDaily(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}getItemBookedDaily`, data , {withCredentials: true})
  }
  getItemBookedDailyBetwen(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}getItemBookedDailyBetwen`, data , {withCredentials: true})
  }
  closeItemD(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}closeItemD`, data , {withCredentials: true})
  }
  addRequestto(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}addRequestto`, data , {withCredentials: true})
  }
  allRequest(): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}allRequest`, 'go' , {withCredentials: true})
  }
  delRequestto(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}delRequestto`, data , {withCredentials: true})
  }
  updateRequestto(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}updateRequestto`, data , {withCredentials: true})
  }
  addRequesttoRF(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}addRequesttoRF`, data , {withCredentials: true})
  }
  allRequestRF(): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}allRequestRF`, 'go' , {withCredentials: true})
  }
  delRequesttoRF(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}delRequesttoRF`, data , {withCredentials: true})
  }
  updateRequesttoRF(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}updateRequesttoRF`, data , {withCredentials: true})
  }
  allRequestRFAns(): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}allRequestRFAns`, 'data' , {withCredentials: true})
  }
  accept(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}accept`, data , {withCredentials: true})
  }
  acceptNo(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}acceptNo`, data , {withCredentials: true})
  }
  allRequestRFAns00(): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}allRequestRFAns00`, 'data' , {withCredentials: true})
  }
  acceptHH(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}acceptHH`, data , {withCredentials: true})
  }
  acceptNoHH(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}acceptNoHH`, data , {withCredentials: true})
  }
  search(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}search`, data , {withCredentials: true})
  }
  searchPay(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}searchPay`, data , {withCredentials: true})
  }
  searchPay0(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}searchPay0`, data , {withCredentials: true})
  }
  searchPay00(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}searchPay00`, data , {withCredentials: true})
  }
  putMoney(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}putMoney`, data , {withCredentials: true})
  }
  searchPay000(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}searchPay000`, data , {withCredentials: true})
  }
  allCa0(): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}allCa0`, 'data' , {withCredentials: true})
  }
  allCa0Account(): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}allCa0Account`, 'data' , {withCredentials: true})
  }
  addIF(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}addIF`, data , {withCredentials: true})
  }
  allSC0(): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}allSC0`, 'go' , {withCredentials: true})
  }
  allSC0Id(): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}allSC0Id`, 'go' , {withCredentials: true})
  }
  allSC0s(): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}allSC0s`, 'go' , {withCredentials: true})
  }
  allSC0sId(): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}allSC0sId`, 'go' , {withCredentials: true})
  }
  addSCN(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}addSCN`, data , {withCredentials: true})
  }
  addSCNAnother(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}addSCNAnother`, data , {withCredentials: true})
  }
  addSCNs(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}addSCNs`, data , {withCredentials: true})
  }
  delSC0(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}delSC0`, data , {withCredentials: true})
  }
  delSC0Offer(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}delSC0Offer`, data , {withCredentials: true})
  }
  delSC0F(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}delSC0F`, data , {withCredentials: true})
  }
  delSC0s(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}delSC0s`, data , {withCredentials: true})
  }
  updateSC0(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}updateSC0`, data , {withCredentials: true})
  }
  updateSC0s(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}updateSC0s`, data , {withCredentials: true})
  }
  addSCN0(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}addSCN0`, data , {withCredentials: true})
  }
  addSCN0s(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}addSCN0s`, data , {withCredentials: true})
  }
  deleteImage(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}deleteImage`, data , {withCredentials: true})
  }
  deleteImageAnother(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}deleteImageAnother`, data , {withCredentials: true})
  }
  addSF(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}addSF`, data , {withCredentials: true})
  }
  allCaNot(): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}allCaNot`, 'go' , {withCredentials: true})
  }
  allCaNotAccount(): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}allCaNotAccount`, 'go' , {withCredentials: true})
  }
  allCustomerP(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}allCustomerP`, data , {withCredentials: true})
  }
  addS0CB(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}addS0CB`, data , {withCredentials: true})
  }
  addS0CBOffer(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}addS0CBOffer`, data , {withCredentials: true})
  }
  allCustomerP0(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}allCustomerP0`, data , {withCredentials: true})
  }
  allCustomerP0Id(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}allCustomerP0Id`, data , {withCredentials: true})
  }
  allCustomerP0Offer(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}allCustomerP0Offer`, data , {withCredentials: true})
  }
  updateSCR(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}updateSCR`, data , {withCredentials: true})
  }
  updateSCR0(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}updateSCR0`, data , {withCredentials: true})
  }
  updateSCR0Offer(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}updateSCR0Offer`, data , {withCredentials: true})
  }
  allID(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}allID`, data , {withCredentials: true})
  }
  allIBD(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}allIBD`, data , {withCredentials: true})
  }
  allIDReturn(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}allIDReturn`, data , {withCredentials: true})
  }
  allID01(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}allID01`, data , {withCredentials: true})
  }
  getItemBooked000(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}getItemBooked000`, data , {withCredentials: true})
  }
  updateSC0sB(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}updateSC0sB`, data , {withCredentials: true})
  }
  allSC0sB(): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}allSC0sB`, 'go' , {withCredentials: true})
  }
  allSC0sBId(): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}allSC0sBId`, 'go' , {withCredentials: true})
  }
  delSC0sB(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}delSC0sB`, data , {withCredentials: true})
  }
  addSCNsB(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}addSCNsB`, data , {withCredentials: true})
  }
  addSCN0sB(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}addSCN0sB`, data , {withCredentials: true})
  }
  getItemBooked000B(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}getItemBooked000B`, data , {withCredentials: true})
  }
  updateSC0A(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}updateSC0A`, data , {withCredentials: true})
  }
  updateSC0AOffer(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}updateSC0AOffer`, data , {withCredentials: true})
  }
  insertSC0AOrder(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}insertSC0AOrder`, data , {withCredentials: true})
  }
  allIBooked(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}allItembooked`, data , {withCredentials: true})
  }
  allItembookedReseved(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}allItembookedReseved`, data , {withCredentials: true})
  }
  allItembookedSales(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}allItembookedSales`, data , {withCredentials: true})
  }
  delAll(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}delAll`, data , {withCredentials: true})
  }
  delAllOffer(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}delAllOffer`, data , {withCredentials: true})
  }
  orderto(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}orderto`, data , {withCredentials: true})
  }
  allCustomerNot(): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}allCustomerNot`, 'data' , {withCredentials: true})
  }
  ordertore(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}ordertore`, data , {withCredentials: true})
  }
  addSCOffer(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}addSCOffer`, data , {withCredentials: true})
  }
  toquotion(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}toquotion`, data , {withCredentials: true})
  }
  getPayments(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}getPayments`, data , {withCredentials: true})
  }
  returnback(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}returnback`, data , {withCredentials: true})
  }
  allIBDP(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}allIBDP`, data , {withCredentials: true})
  }
  allSC0Visit(): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}allSC0Visit`, 'data' , {withCredentials: true})
  }
  getControlsTypeEmployee(): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}getControlsTypeEmployee`, 'data' , {withCredentials: true})
  }
  allAttend(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}allAttend`, data , {withCredentials: true})
  }
  allAttendSalary(): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}allAttendSalary`, 'data' , {withCredentials: true})
  }
  addAttenSalary(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}addAttenSalary`, data , {withCredentials: true})
  }
  getItemBooked000BDate(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}getItemBooked000BDate`, data , {withCredentials: true})
  }
  allpaymentCustomer(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}allpaymentCustomer`, data , {withCredentials: true})
  }
  allpaymentCustomerDate(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}allpaymentCustomerDate`, data , {withCredentials: true})
  }
  delUAttend(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}delUAttend`, data , {withCredentials: true})
  }
  permission(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}permission`, data , {withCredentials: true})
  }
  addPermission(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}addPermission`, data , {withCredentials: true})
  }
  UpdatePermission(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}UpdatePermission`, data , {withCredentials: true})
  }
  upAccount(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}upAccount`, data , {withCredentials: true})
  }
  addCaAcountSubNew(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}addCaAcountSubNew`, data , {withCredentials: true})
  }
  allCa0AccountNewSub(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}allCa0AccountNewSub`, data , {withCredentials: true})
  }
  updateCaAccount00(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}updateCaAccount00`, data , {withCredentials: true})
  }
  allCashPaymentsDate(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}allCashPaymentsDate`, data , {withCredentials: true})
  }
  allCashPaymentsDateBtween(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}allCashPaymentsDateBtween`, data , {withCredentials: true})
  }
  allCashPaymentsDate2(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}allCashPaymentsDate2`, data , {withCredentials: true})
  }
  allCashPaymentsDate2Btween(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}allCashPaymentsDate2Btween`, data , {withCredentials: true})
  }
  allCaAccountCheckSub(): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}allCaAccountCheckSub`, 'data' , {withCredentials: true})
  }
  updateUserCashPayments(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}updateUserCashPayments`, data , {withCredentials: true})
  }
  updateUserCashPaymentsDaily(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}updateUserCashPaymentsDaily`, data , {withCredentials: true})
  }
  updateUserCashPaymentsDailyPay(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}updateUserCashPaymentsDailyPay`, data , {withCredentials: true})
  }
  updateUserCashPayments2(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}updateUserCashPayments2`, data , {withCredentials: true})
  }
  deleteQuotation(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}deleteQuotation`, data , {withCredentials: true})
  }
  delUAttendPay(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}delUAttendPay`, data , {withCredentials: true})
  }
  addPay00File(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}addPay00File`, data , {withCredentials: true})
  }
  getItemOstaze(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}getItemOstaze`, data , {withCredentials: true})
  }
  getItemOstazeShahry(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}getItemOstazeShahry`, data , {withCredentials: true})
  }
  getItemBookedDa5l(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}getItemBookedDa5l`, data , {withCredentials: true})
  }
  getItemOstazeShahryMizan(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}getItemOstazeShahryMizan`, data , {withCredentials: true})
  }
  codeDetails(data: any): Observable<any>{
    return this._HttpClient.post(`${this.baseUrl}codeDetails`, data , {withCredentials: true})
  }

}
